// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__4Ysqp","ellipsis":"styles_ellipsis__ajbni","text2AndMoreLines":"styles_text2AndMoreLines__hqCkL","tooltipTrigger":"styles_tooltipTrigger__KYch3"};